/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Closing_Lede_2Inputs */

const en_home_closing_lede_2 = /** @type {(inputs: Home_Closing_Lede_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let’s see what a system could do about it.`)
};

const lv_home_closing_lede_2 = /** @type {(inputs: Home_Closing_Lede_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīsim, ko sistēma ar to var izdarīt.`)
};

/**
* | output |
* | --- |
* | "Let’s see what a system could do about it." |
*
* @param {Home_Closing_Lede_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_closing_lede_2 = /** @type {((inputs?: Home_Closing_Lede_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Closing_Lede_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_closing_lede_2(inputs)
	return en_home_closing_lede_2(inputs)
});